const formatDate = (date: string | number) => {
  let d = date;
  if(typeof d === 'string') {
    d.replace(/-/g, '/');
  }
  return d;
}

export const date = (date: string | number, type: string) => {
  if(!date) { //如果没有传入日期时就不进行处理了
    return '';
  }
  let newDate = formatDate(date);
  const d = new Date(newDate);
  const year = d.getFullYear().toString() ;
  const month = ('0' + (d.getMonth() + 1).toString()).slice(-2);
  const day = ('0' + (d.getDate().toString())).slice(-2);
  const hour = ('0' + d.getHours()).slice(-2);
  const minute = ('0' + (d.getMinutes())).slice(-2);
  let dateStr = '';

  const _time = hour + ':' + minute;
  const _date = month + '-' + day;
  switch(type) {
    case 'date':
      dateStr = year + '-' + _date;
      break;
    case 'dayTime':
      dateStr = _date + ' ' + _time;
      break;
    case 'dateWithTime':
      dateStr = year + '-' + _date + ' ' + _time;
      break;
    case 'time':
      dateStr = _time;
      break;
    case 'hourWithMinute':
      dateStr = hour + ':' + minute;
      break;
    case 'cTime':
      dateStr = month + '月' + day + '日 ' + _time;
      break;
    case 'cDate':
      dateStr = month + '月' + day + '日 ';
      break;
    //no default
  }
  return dateStr;
}